module.exports = __webpack_public_path__ + "img/logo_white.c7505b7a.png";